import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import ArticleItem from '~/components/Layout/Builders/ArticleItem';
import type { ArticleItemType } from '~/types/ArticleItemType';
import {
  isVideoOfSize,
  mobileVideoPlacementExperiment,
  desktopVideoPlacementExperiment,
} from '~/utilities/experiments/videoPlacement';

type ArticleBuilderType = {
  items: ArticleItemType[];
  experiments?: string[];
};

export default component$<ArticleBuilderType>(
  ({ items, experiments }): JSX.Element => {
    let itemsToRender = items;

    // TODO: EXP: Remove once the mobile video placement experiment ends.
    if (mobileVideoPlacementExperiment(experiments)) {
      // Remove the mobile video from its default position
      itemsToRender = itemsToRender.filter(
        (item) => !isVideoOfSize(item, 'sm')
      );
    }

    // TODO: EXP: Remove once the desktop video placement experiment ends.
    if (desktopVideoPlacementExperiment(experiments)) {
      // Remove the desktop video from its default position
      itemsToRender = itemsToRender.filter(
        (item) => !isVideoOfSize(item, 'lg')
      );
    }

    return itemsToRender.map((each, index) => (
      <ArticleItem key={index} item={each} experiments={experiments} />
    ));
  }
);
